// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"e54bf99b","131":"acde7b97","591":"5ba6299d","722":"8a601436","856":"b521d4d9","943":"dcd6de9e"}[chunkId] + ".chunk.css";
};